import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import IntroSequenceImage from '../../../assets/images/invoices_intro_sequence.svg';
import LogTimeSequenceImage from '../../../assets/images/invoices_log_time_sequence.svg';
import TrackTimeSequenceImage from '../../../assets/images/invoices_track_sequence.svg';
import ApproveSequenceImage from '../../../assets/images/invoices_approve_sequence.svg';
import SubmitSequenceImage from '../../../assets/images/invoices_submit_sequence.svg';
import ReadySequenceImage from '../../../assets/images/invoices_ready_sequence.svg';
import InviteSequenceImage from '../../../assets/images/invoices_invite_sequence.svg';

const imageDict = {
  1: {
    consultant: LogTimeSequenceImage,
    employer: TrackTimeSequenceImage,
  },
  2: {
    consultant: SubmitSequenceImage,
    employer: ApproveSequenceImage,
  },
  3: {
    consultant: ReadySequenceImage,
    employer: InviteSequenceImage,
  },
};

const renderDescriptionContent = (type, sequence) => {
  switch (sequence) {
    case 0: {
      return (
        <Fragment>
          {
            type === 'consultant' ? (
              <Fragment>
                <h2>New to My Timesheets?</h2>
                <p>My Timesheets is Clora's time tracking and billing tool for you to log working hours, expenses.</p>
              </Fragment>
            ) : (
              <Fragment>
                <h2>New to Timesheets Portal?</h2>
                <p>
                  Timesheets Portal is Clora's time tracking tool for you to review
                  and approve hours and expenses logged by consultants.
                </p>
              </Fragment>
            )
          }
        </Fragment>
      );
    }
    case 1: {
      return (
        <Fragment>
          {
            type === 'consultant' ? (
              <Fragment>
                <h2>Log Time and Expenses</h2>
                <p>
                  Now employers can view your activities at any time.
                  Make sure to include details for all line items.
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <h2>Track Time and Expenses</h2>
                <p>
                  Once your projects start you can view monthly
                  consultant timesheets at any time at the portal.
                </p>
              </Fragment>
            )
          }
        </Fragment>
      );
    }
    case 2: {
      return (
        <Fragment>
          {
            type === 'consultant' ? (
              <Fragment>
                <h2>Submit Your Timesheets</h2>
                <p>
                  By the 2nd of the next month to ensure timely payments.
                  Your hiring managers will approve or request edits to your billed hours.
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <h2>Approve Timesheets</h2>
                <p>
                  Review and approve monthly timesheets within 5 business days
                  after the consultant submission.
                </p>
              </Fragment>
            )
          }
        </Fragment>
      );
    }
    case 3: {
      return (
        <Fragment>
          {
            type === 'consultant' ? (
              <Fragment>
                <h2>Access and Export</h2>
                <p>
                  Once your timesheet is approved, you will be notified and
                  able to export a final PDF for your records.
                </p>
              </Fragment>
            ) : (
              <Fragment>
                <h2>Invite Your Team</h2>
                <p>
                  Hiring managers can invite other colleagues to track and approve
                  consultants' timesheets.
                </p>
              </Fragment>
            )
          }
        </Fragment>
      );
    }
    default:
      return null;
  }
};

const renderImageContent = (type, sequence) => {
  if (sequence === 0) return IntroSequenceImage;
  return imageDict[sequence][type];
};

function EmployerSequenceRenderer({ type, sequence, closeModal }) {
  return (
    <div className="walkthrough-content">
      <div className="walkthrough-description">
        {renderDescriptionContent(type, sequence)}
      </div>
      <div className="walkthrough-display">
        <span
          className="close"
          tabIndex={0}
          role="link"
          onClick={() => closeModal()}
        >
          <i className="fas fa-times" />
        </span>
        <img src={renderImageContent(type, sequence)} alt="invoiceDisplay" />
      </div>
    </div>
  );
}

EmployerSequenceRenderer.propTypes = {
  type: PropTypes.string.isRequired,
  sequence: PropTypes.number.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default EmployerSequenceRenderer;
